import { Link } from 'react-router-dom';
import { ExternalLink, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://cdn.prod.website-files.com/65bab6e8de90f51ce337cb2c/65ca81b04a44869f7f5747ca_LOGO_S2_WHITE_TRANSPARENT.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] border-t border-white/5" data-testid="footer">
      <div className="container-custom py-20 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-5">
            <img 
              src={LOGO_URL} 
              alt="Second Souffle Production" 
              className="h-12 w-auto mb-6"
            />
            <p className="text-[#a1a1aa] text-base leading-relaxed max-w-md mb-8">
              Un fonds de dotation qui fait du cinéma un vecteur de sensibilisation 
              et d'impact sociétal. Distributeur non commercial d'œuvres porteuses de sens.
            </p>
            <Link
              to="/faire-un-don"
              className="btn-primary inline-block"
              data-testid="footer-donate-btn"
            >
              Soutenir notre mission
            </Link>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">
              Navigation
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="footer-link" data-testid="footer-link-home">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/projets" className="footer-link" data-testid="footer-link-projects">
                  Nos projets
                </Link>
              </li>
              <li>
                <Link to="/agenda" className="footer-link" data-testid="footer-link-agenda">
                  Agenda
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link" data-testid="footer-link-about">
                  Qui sommes-nous
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
              <li>
                <a 
                  href="https://wippfestival.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link flex items-center gap-2"
                  data-testid="footer-link-wipp"
                >
                  Festival WiPP
                  <ExternalLink size={12} className="opacity-50" />
                </a>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/cinemaquis/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link flex items-center gap-2"
                  data-testid="footer-link-cinemaquis"
                >
                  Cinémaquis
                  <ExternalLink size={12} className="opacity-50" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-[#a1a1aa]">
                <Mail size={18} className="mt-1 text-[#D4AF37]" />
                <a 
                  href="mailto:contact@secondsouffleprod.com" 
                  className="footer-link"
                  data-testid="footer-email"
                >
                  contact@secondsouffleprod.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#a1a1aa]">
                <MapPin size={18} className="mt-1 text-[#D4AF37]" />
                <span>Paris, France</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="divider mt-16 mb-8" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[#71717a]">
          <p>© {currentYear} Second Souffle Production. Tous droits réservés.</p>
          <p>Fonds de dotation - Distributeur non commercial</p>
        </div>
      </div>
    </footer>
  );
};
